import type { ReviewPhotoGalleryProps } from "../../types/components/reviewPhotoGallery";
import type { GalleryImage } from "../../types/components/imageGallery";

export const mapPhotoGalleryProps = ({
  reviewPhotoList,
}: ReviewPhotoGalleryProps): GalleryImage[] =>
  reviewPhotoList.map(({ fullSizeUrl }) => ({
    url: fullSizeUrl,
  }));
